import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const { token } = useParams(); // Get the token from the URL

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`https://nrdruhs.in/api/reset-password/${token}`, { newPassword: password });
            const { message, success } = response.data;

            if (success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Password Reset Successful',
                    text: message,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error Resetting Password',
                    text: message,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error Resetting Password',
                text: 'Please try again.',
            });
        }
    };

    return (
        <div className="container h-100" style={{ paddingTop: 60 }}>
            <div className="row h-100 justify-content-center align-items-center">
                <div className="col-md-6">
                    <h2 className="my-4">Reset Password</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label style={{ fontWeight: 'bold' }}>New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                style={{ width: '100%' }}
                                value={password}
                                onChange={handlePasswordChange}
                            />
                        </div>
                        <button type="submit" className="btn btn-primary mt-3">
                            Reset Password
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
